import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, CalendarDays, MessageSquare, Beer, UserCircle2 } from "lucide-react";

const Item = ({ to, icon: Icon, label, testid }) => (
  <NavLink
    to={to}
    data-testid={testid}
    className={({ isActive }) => `flex flex-col items-center justify-center gap-1 w-full py-2 ${isActive ? "text-rose-200" : "text-rose-100/60"}`}
  >
    <Icon size={20} />
    <span className="text-[10px]">{label}</span>
  </NavLink>
);

export const BottomNav = () => {
  const location = useLocation();
  
  // Hide BottomNav on Stage view (fullscreen beamer mode)
  if (location.pathname.includes('/predictions/stage/')) {
    return null;
  }
  
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 border-t border-white/10 bg-[#12090c]/95 backdrop-blur-xl">
      <div className="grid grid-cols-5 max-w-md mx-auto">
        <Item to="/" icon={Home} label="Home" testid="nav-dashboard" />
        <Item to="/calendar" icon={CalendarDays} label="Kalender" testid="nav-calendar" />
        <Item to="/chat" icon={MessageSquare} label="Chat" testid="nav-chat" />
        <Item to="/kiosk" icon={Beer} label="Kiosk" testid="nav-kiosk" />
        <Item to="/profil" icon={UserCircle2} label="Profil" testid="nav-profil" />
      </div>
    </nav>
  );
};
